import { useQuery } from '@tanstack/react-query';
import { suburbsApi, type SuburbListParams } from './suburbs.api';

export const suburbsQueryKeys = {
  all: ['suburbs'] as const,
  lists: () => [...suburbsQueryKeys.all, 'list'] as const,
  list: (params: SuburbListParams) => [...suburbsQueryKeys.lists(), params] as const,
  detail: (slug: string) => [...suburbsQueryKeys.all, 'detail', slug] as const,
};

export const useSuburbsList = (params: SuburbListParams) => {
  return useQuery({
    queryKey: suburbsQueryKeys.list(params),
    queryFn: () => suburbsApi.list(params),
  });
};

export const useSuburbBySlug = (slug: string) => {
  return useQuery({
    queryKey: suburbsQueryKeys.detail(slug),
    queryFn: () => suburbsApi.getBySlug(slug),
    enabled: !!slug,
  });
};
